import { ConfirmDialog } from "../../../components/ui/overlay/ConfirmDialog";

export function AvailabilityDialog({ open, nextStatus, onConfirm, onClose }: { open: boolean; nextStatus: "OPEN" | "CLOSED"; onConfirm: () => void; onClose: () => void }) {
  return <ConfirmDialog open={open} title={nextStatus === "OPEN" ? "確認開放問卷" : "確認截止問卷"} description="此操作只變更收件狀態，不會變更固定題目或既有填答。" confirmLabel="確認" onConfirm={onConfirm} onClose={onClose} />;
}
